/** Auto-generated by scripts/build-puzzle-catalog.mjs — do not edit by hand */

export const PUZZLE_CATALOG_ENTRIES = [
  {
    "weekIndex": 1,
    "difficulty": "easy",
    "estimatedRating": 1350,
    "fen": "5r1k/ppR5/2n2qpb/6Np/8/1B6/P4PPP/3R2K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 3,
    "freePlay": true,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c7",
          "to": "h7"
        },
        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
        "accept": "checkmate"
      }
    ],
    "subtitle": "Kniha č. 94 — mat vežou Rh7# (plná doska, útok na kráľa).",
    "solution": "Rh7#"
  },
  {
    "weekIndex": 1,
    "difficulty": "medium",
    "estimatedRating": 1550,
    "fen": "r3br2/1pq2p1p/p3pNp1/4P1k1/1n1P4/7R/PP2B1PP/R6K w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h3",
          "to": "g3"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g5",
              "to": "h4"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g3",
                  "to": "g4"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 183 — mat v dvoch: Rg3+ a Rg4# (veža, jazdec, plná doska).",
    "solution": "Rg3+ Kh4 Rg4#"
  },
  {
    "weekIndex": 1,
    "difficulty": "hard",
    "estimatedRating": 1850,
    "fen": "1r6/7p/2R3p1/pp2p3/k3B2r/P7/1PP3P1/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c6",
          "to": "b6"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "b5",
              "to": "b4"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "e4",
                  "to": "c6"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 187 — Rb6 a mat strelcom Bc6# (iná pozícia ako ľahšia úloha).",
    "solution": "Rb6 b4 Bc6#"
  },
  {
    "weekIndex": 2,
    "difficulty": "easy",
    "estimatedRating": 1382,
    "fen": "2r1r1k1/ppp2Npp/2p1Pq2/2b3N1/2p5/7Q/PPP3P1/2KR1R2 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "f7",
          "to": "d8"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "e8",
              "to": "f8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "h3",
                  "to": "h7"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 175 — Nd8 a mat Qxh7# (bohatá pozícia).",
    "solution": "Nd8 Rf8 Qxh7#"
  },
  {
    "weekIndex": 2,
    "difficulty": "medium",
    "estimatedRating": 1593,
    "fen": "2R5/b4kB1/r4nN1/5P2/r2p4/2pK4/2P5/7R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c8",
          "to": "c7"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "f7",
              "to": "g8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "h1",
                  "to": "h8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 185 — Rc7+ a mat Rh8# (dve veže a strelci).",
    "solution": "Rc7+ Kg8 Rh8#"
  },
  {
    "weekIndex": 2,
    "difficulty": "hard",
    "estimatedRating": 1905,
    "fen": "2r4k/2qb1rb1/p3pN1p/1p2PpN1/5P1P/8/PPP5/2K3RR w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h4",
          "to": "h5"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "c8",
              "to": "d8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g5",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 188 — h5, Rd8 a Nxf7# (jazdecká kombinácia).",
    "solution": "h5 Rd8 Nxf7#"
  },
  {
    "weekIndex": 3,
    "difficulty": "easy",
    "estimatedRating": 1414,
    "fen": "2r1k3/5ppp/8/8/8/1R6/5Q2/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 19,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "b3",
          "to": "b4"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "c8",
              "to": "d8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "b4",
                  "to": "b7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "e8",
                      "to": "f8"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "f2",
                          "to": "f7"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kombinácia Rb4–Rb7 a mat dámou na f7 (tri biele ťahy).",
    "solution": "Rb4 Rd8 Rb7+ Kf8 Qxf7#"
  },
  {
    "weekIndex": 3,
    "difficulty": "medium",
    "estimatedRating": 1635,
    "fen": "8/r3Bpkp/4q1p1/8/5Q1K/8/8/8 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "f4",
          "to": "e5"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g7",
              "to": "h6"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "e7",
                  "to": "f8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 192 — Qe5+ Kh6 a Bf8# (dáma a strelec).",
    "solution": "Qe5+ Kh6 Bf8#"
  },
  {
    "weekIndex": 3,
    "difficulty": "hard",
    "estimatedRating": 1959,
    "fen": "6k1/8/8/4N3/5q2/8/8/2R3K1 w - - 0 1",
    "playerColor": "w",
    "win": "black_queen_captured",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c1",
          "to": "c8"
        },
        "wrong": "Začnite šachom podľa plánu úlohy.",
        "accept": "check"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "f4",
              "to": "f8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "c8",
                  "to": "f8"
                },
                "wrong": "Týmto ťahom nezoberiete čiernu dámu.",
                "accept": "black_queen_captured"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Taktika: šach vežou a zisk čiernej dámy.",
    "solution": "Rc8+ Qf8 Rxf8"
  },
  {
    "weekIndex": 4,
    "difficulty": "easy",
    "estimatedRating": 1445,
    "fen": "6k1/4pppp/8/8/8/5N2/5Q2/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "f3",
          "to": "e5"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "f8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "f2",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Jazdec a dáma: Ne5+ a Qxf7# (mat v dvoch, viac figúr).",
    "solution": "Ne5+ Kf8 Qxf7#"
  },
  {
    "weekIndex": 4,
    "difficulty": "medium",
    "estimatedRating": 1678,
    "fen": "1rn5/kp3ppp/p1q5/N1Q5/8/7P/PP3PP1/3R2K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 23,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "a5",
          "to": "c6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "a7",
              "to": "a8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "c5",
                  "to": "b6"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "c8",
                      "to": "a7"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "b6",
                          "to": "a7"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 381 — väzba: Nxc6+ a mat Qxa7# (taktický motív).",
    "solution": "Nxc6+ Ka8 Qb6 Na7 Qxa7#"
  },
  {
    "weekIndex": 4,
    "difficulty": "hard",
    "estimatedRating": 2014,
    "fen": "8/8/3r3k/p5rp/3N1N1R/PP6/1KP5/8 w - - 0 1",
    "playerColor": "w",
    "win": "decisive",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "d4",
          "to": "f5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "h6",
              "to": "h7"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "f4",
                  "to": "g6"
                },
                "wrong": "Týmto ťahom nezískate rozhodujúcu výhodu — skúste taktický ťah z riešenia.",
                "accept": "decisive"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 412 — Nf5+ a vidlička Ng6 (dvojitý úder).",
    "solution": "Nf5+ Kh7 Ng6"
  },
  {
    "weekIndex": 5,
    "difficulty": "easy",
    "estimatedRating": 1477,
    "fen": "6k1/5ppp/8/8/8/8/R7/4K3 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "a2",
          "to": "a3"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "a3",
                  "to": "a8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Mat v dvoch po a-linke: Ra3+ a Ra8#.",
    "solution": "Ra3+ Kh8 Ra8#"
  },
  {
    "weekIndex": 5,
    "difficulty": "medium",
    "estimatedRating": 1721,
    "fen": "5rk1/5ppp/8/8/8/8/5Q2/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 26,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "f2",
          "to": "e3"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "f8",
              "to": "e8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "e3",
                  "to": "d4"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "e8",
                      "to": "f8"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "d4",
                          "to": "c5"
                        },
                        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
                      },
                      {
                        "who": "bot",
                        "pick": "main",
                        "choices": [
                          {
                            "move": {
                              "from": "f8",
                              "to": "c8"
                            },
                            "main": true,
                            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                            "then": [
                              {
                                "who": "user",
                                "suggest": {
                                  "from": "c5",
                                  "to": "c8"
                                },
                                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                                "accept": "checkmate"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Dámska kombinácia proti veži — viacťahové taktické finále.",
    "solution": "Qe3+ Re8 Qd4+ Rf8 Qc5+ Rc8 Qxc8#"
  },
  {
    "weekIndex": 5,
    "difficulty": "hard",
    "estimatedRating": 2068,
    "fen": "n2r2k1/pr2b1B1/1p6/3pq3/P7/8/1P3RPP/5R1K w - - 0 1",
    "playerColor": "w",
    "win": "black_queen_captured",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "g7",
          "to": "e5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "d8",
              "to": "b8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "e5",
                  "to": "b8"
                },
                "wrong": "Týmto ťahom nezoberiete čiernu dámu.",
                "accept": "black_queen_captured"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 382 — väzba: Bxe5 a Bxb8 (zisk dámy; veža na d8).",
    "solution": "Bxe5 Qb8 Bxb8"
  },
  {
    "weekIndex": 6,
    "difficulty": "easy",
    "estimatedRating": 1509,
    "fen": "6k1/5ppp/8/8/8/8/R7/4K3 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "a2",
          "to": "a3"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "a3",
                  "to": "a8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Mat v dvoch po a-linke: Ra3+ a Ra8# (legálna pozícia, overené cez chess.js).",
    "solution": "Ra3+ Kh8 Ra8#"
  },
  {
    "weekIndex": 6,
    "difficulty": "medium",
    "estimatedRating": 1764,
    "fen": "6k1/5ppp/8/8/8/8/4Q2R/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "e2",
          "to": "a6"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "a6",
                  "to": "a8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Mat v dvoch: Qa6+ a doraz Qa8# (dáma a veža).",
    "solution": "Qa6+ Kh8 Qa8#"
  },
  {
    "weekIndex": 6,
    "difficulty": "hard",
    "estimatedRating": 2123,
    "fen": "6k1/8/8/8/8/5q2/8/2R3K1 w - - 0 1",
    "playerColor": "w",
    "win": "black_queen_captured",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c1",
          "to": "c2"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "f3",
              "to": "c6"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "c2",
                  "to": "c6"
                },
                "wrong": "Týmto ťahom nezoberiete čiernu dámu.",
                "accept": "black_queen_captured"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Získajte dámu: Rc2 a výmena po Qc6.",
    "solution": "Rc2 Qc6 Rxc6"
  },
  {
    "weekIndex": 7,
    "difficulty": "easy",
    "estimatedRating": 1541,
    "fen": "n2r2k1/pr2b1B1/1p6/3pq3/P7/8/1P3RPP/5R1K w - - 0 1",
    "playerColor": "w",
    "win": "black_queen_captured",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "g7",
          "to": "e5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "d8",
              "to": "b8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "e5",
                  "to": "b8"
                },
                "wrong": "Týmto ťahom nezoberiete čiernu dámu.",
                "accept": "black_queen_captured"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 382 — väzba: Bxe5 a Bxb8 (zisk dámy).",
    "solution": "Bxe5 Qb8 Bxb8"
  },
  {
    "weekIndex": 7,
    "difficulty": "medium",
    "estimatedRating": 1806,
    "fen": "2rqkb1r/pp1npppp/2Q2n2/2pPN3/1p6/8/PP3PPP/R3KB1R w KQkq - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 23,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "e5",
          "to": "d7"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "d8",
              "to": "d7"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "f1",
                  "to": "b5"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "f6",
                      "to": "g8"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "c6",
                          "to": "d7"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 383 — väzba: Nxd7, Bb5+ a mat Qxd7#.",
    "solution": "Nxd7 Qxd7 Bb5+ Ng8 Qxd7#"
  },
  {
    "weekIndex": 7,
    "difficulty": "hard",
    "estimatedRating": 2177,
    "fen": "r7/bp1n4/N1p3kr/q4ppp/3B1PPP/pPPQ2P1/P7/2KR3R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 27,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "g4",
          "to": "f5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g6",
              "to": "f7"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "d4",
                  "to": "c5"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "f7",
                      "to": "e8"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "d3",
                          "to": "d7"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 384 — väzba: gxf5+ a mat Qxd7#.",
    "solution": "gxf5+ Kf7 Bc5 Ke8 Qxd7#"
  },
  {
    "weekIndex": 8,
    "difficulty": "easy",
    "estimatedRating": 1573,
    "fen": "8/7k/8/5K2/8/3R4/8/1B6 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "f5",
          "to": "f6"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "h7",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "d3",
                  "to": "d8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 184 — kráľ a veža: Kf6 a mat Rd8#.",
    "solution": "Kf6 Kh8 Rd8#"
  },
  {
    "weekIndex": 8,
    "difficulty": "medium",
    "estimatedRating": 1849,
    "fen": "6k1/5pp1/8/6p1/8/8/6Q1/6K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "g2",
          "to": "d5"
        },
        "wrong": "Tento ťah nevedie k matu v dvoch — skúste iný úvod.",
        "accept": "mate_in_2_opening"
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "f8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "d5",
                  "to": "d8"
                },
                "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                "accept": "checkmate"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Mat v dvoch: Qd5+ a doraz Qd8# (dáma na diagonále).",
    "solution": "Qd5+ Kf8 Qd8#"
  },
  {
    "weekIndex": 8,
    "difficulty": "hard",
    "estimatedRating": 2232,
    "fen": "6k1/8/8/4N3/4q3/8/8/2R3K1 w - - 0 1",
    "playerColor": "w",
    "win": "black_queen_captured",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "e5",
          "to": "c6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "e4",
              "to": "e5"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "c6",
                  "to": "e5"
                },
                "wrong": "Týmto ťahom nezoberiete čiernu dámu.",
                "accept": "black_queen_captured"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Taktika: jazdec na c6 a zisk čiernej dámy po Qe5.",
    "solution": "Nc6 Qe5 Nxe5"
  },
  {
    "weekIndex": 9,
    "difficulty": "easy",
    "estimatedRating": 1605,
    "fen": "8/3P4/2P1k1p1/b3Bp2/6Pp/5K1P/p7/8 w - - 0 1",
    "playerColor": "w",
    "win": "decisive",
    "maxMoves": 12,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c6",
          "to": "c7"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "e6",
              "to": "d7"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "c7",
                  "to": "c8",
                  "promotion": "q"
                },
                "wrong": "Týmto ťahom nezískate rozhodujúcu výhodu — skúste taktický ťah z riešenia.",
                "accept": "decisive"
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "d7",
                      "to": "c8"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 411 — postup c7–c8 a zisk kvality.",
    "solution": "c7 Kxd7 c8=Q Kxc8"
  },
  {
    "weekIndex": 9,
    "difficulty": "medium",
    "estimatedRating": 1892,
    "fen": "2r1k3/1p4pp/p3pP2/2n3N1/4P3/5PP1/PP4KP/2R5 w - - 0 1",
    "playerColor": "w",
    "win": "decisive",
    "maxMoves": 14,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c1",
          "to": "c5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "c8",
              "to": "c5"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g5",
                  "to": "e6"
                },
                "wrong": "Týmto ťahom nezískate rozhodujúcu výhodu — skúste taktický ťah z riešenia.",
                "accept": "decisive"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 410 — dvojitý úder: Rxc5 a Nxe6+ (pešiak f7).",
    "solution": "Rxc5 Rxc5 Nxe6+"
  },
  {
    "weekIndex": 9,
    "difficulty": "hard",
    "estimatedRating": 2286,
    "fen": "8/8/3r3k/p5rp/3N1N1R/PP6/1KP5/8 w - - 0 1",
    "playerColor": "w",
    "win": "decisive",
    "maxMoves": 16,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "d4",
          "to": "f5"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "h6",
              "to": "h7"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "f4",
                  "to": "g6"
                },
                "wrong": "Týmto ťahom nezískate rozhodujúcu výhodu — skúste taktický ťah z riešenia.",
                "accept": "decisive"
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 412 — Nf5+ a vidlička Ng6.",
    "solution": "Nf5+ Kh7 Ng6"
  },
  {
    "weekIndex": 10,
    "difficulty": "easy",
    "estimatedRating": 1636,
    "fen": "5r2/ppR2Nkp/2n1pq2/1B5p/8/1B6/P2Q1PPP/3R2K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 19,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c7",
          "to": "c6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "a7",
              "to": "a6"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "b3",
                  "to": "e6"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g6"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "d2",
                          "to": "h6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 193 — Rxc6, Bxe6 a mat Qh6#.",
    "solution": "Rxc6 a6 Bxe6 Kg6 Qh6#"
  },
  {
    "weekIndex": 10,
    "difficulty": "medium",
    "estimatedRating": 1935,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 23,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g6"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — Qg6, Qxf7 a mat jazdcom Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 g6 Nxg6#"
  },
  {
    "weekIndex": 10,
    "difficulty": "hard",
    "estimatedRating": 2341,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 27,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "f6",
                      "to": "e7"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — ťažšia obrana Be7, finiš Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 Be7 Nxg6#"
  },
  {
    "weekIndex": 11,
    "difficulty": "easy",
    "estimatedRating": 1668,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 19,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g6"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — Qg6, Qxf7 a mat jazdcom Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 g6 Nxg6#"
  },
  {
    "weekIndex": 11,
    "difficulty": "medium",
    "estimatedRating": 1977,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 23,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g5"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — obrana g5, finiš Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 g5 Nxg6#"
  },
  {
    "weekIndex": 11,
    "difficulty": "hard",
    "estimatedRating": 2395,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 27,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "d3",
                      "to": "c4"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — čierna dáma na c4, mat Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 Qc4 Nxg6#"
  },
  {
    "weekIndex": 12,
    "difficulty": "easy",
    "estimatedRating": 1700,
    "fen": "5r2/ppR2Nkp/2n1pq2/1B5p/8/1B6/P2Q1PPP/3R2K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 19,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c7",
          "to": "c6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "a7",
              "to": "a5"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "b3",
                  "to": "e6"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g6"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "d2",
                          "to": "h6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 193 — záverečný týždeň: Rxc6, Bxe6 a Qh6#.",
    "solution": "Rxc6 a5 Bxe6 Kg6 Qh6#"
  },
  {
    "weekIndex": 12,
    "difficulty": "medium",
    "estimatedRating": 2020,
    "fen": "5r2/ppR2Nkp/2n1pq2/1B5p/8/1B6/P2Q1PPP/3R2K1 w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 23,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "c7",
          "to": "c6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "b7",
              "to": "b6"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "b3",
                  "to": "e6"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "g7",
                      "to": "g6"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "d2",
                          "to": "h6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 193 — varianta po b6.",
    "solution": "Rxc6 b6 Bxe6 Kg6 Qh6#"
  },
  {
    "weekIndex": 12,
    "difficulty": "hard",
    "estimatedRating": 2450,
    "fen": "6k1/5pp1/5b2/7Q/7N/1P1q4/P1P5/1K5R w - - 0 1",
    "playerColor": "w",
    "win": "checkmate",
    "maxMoves": 27,
    "freePlay": false,
    "play": [
      {
        "who": "user",
        "suggest": {
          "from": "h5",
          "to": "g6"
        },
        "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
      },
      {
        "who": "bot",
        "pick": "main",
        "choices": [
          {
            "move": {
              "from": "g8",
              "to": "h8"
            },
            "main": true,
            "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
            "then": [
              {
                "who": "user",
                "suggest": {
                  "from": "g6",
                  "to": "f7"
                },
                "wrong": "Týmto ťahom nepostupujete správne — skúste iný ťah."
              },
              {
                "who": "bot",
                "pick": "main",
                "choices": [
                  {
                    "move": {
                      "from": "d3",
                      "to": "c4"
                    },
                    "main": true,
                    "hint": "Počítač odohral hlavnú obranu — pokračujte podľa plánu.",
                    "then": [
                      {
                        "who": "user",
                        "suggest": {
                          "from": "h4",
                          "to": "g6"
                        },
                        "wrong": "Týmto ťahom nedáte mat — skúste iný finiš.",
                        "accept": "checkmate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "subtitle": "Kniha č. 198 — koruna festivalu: Qc4 a mat Nxg6#.",
    "solution": "Qg6+ Kh8 Qxf7 Qc4 Nxg6#"
  }
];
